module.exports = __webpack_public_path__ + "img/stripes.1592faf5.webp";